import User from '@authentication/models/user';
import axiosClient from '@services/api';

import EndPoints from '@services/endpoints';

import { AxiosResponse } from 'axios';

export const getCurrentUser = (): Promise<AxiosResponse<User, any>> | null => {
  return axiosClient.get(EndPoints.user.getCurrentUser);
};
